// extracted by mini-css-extract-plugin
export default {"account":"MyAccount__account--3Wb","loginName":"MyAccount__loginName--2dl"};